import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnDemandPreloadingStrategy } from '@freelancer/preload-route';
import { ShellGuard } from './shell-guard.service';

const appRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        canActivate: [ShellGuard],
        data: {
          // "argument" for shell guard to avoid duplicating reroute logic
          loggedIn: true,
        },
        // if logged in, lazy-load the logged in shell
        loadChildren: () =>
          import('app/app-shell/logged-in-routing.module').then(
            m => m.LoggedInRoutingModule,
          ),
      },
      {
        path: '',
        canActivate: [ShellGuard],
        data: {
          loggedIn: false,
        },
        loadChildren: () =>
          import('app/app-shell/logged-out-routing.module').then(
            m => m.LoggedOutRoutingModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      initialNavigation: 'enabled',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      urlUpdateStrategy: 'eager',
      preloadingStrategy: OnDemandPreloadingStrategy,
    }),
    CommonModule,
  ],
  providers: [OnDemandPreloadingStrategy],
  exports: [RouterModule],
})
export class ShellRoutingModule {}
